module.exports = __webpack_public_path__ + "static/media/trial1_4.6f5bbb67.png";